var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { class: { "py-0": _vm.isMobile }, attrs: { xs12: "", sm8: "" } },
            [
              _c(
                "v-autocomplete",
                {
                  attrs: {
                    label: "Select Student",
                    items: _vm.studentsArray,
                    clearable: true,
                    "error-messages": _vm.studentSearchError,
                    "return-object": true,
                    "search-input": _vm.studentSearchInput,
                    "item-text": "firstName",
                    "item-value": "studentId",
                    loading: _vm.studentSearchLoading,
                    "no-filter": true
                  },
                  on: {
                    "update:searchInput": function($event) {
                      _vm.studentSearchInput = $event
                    },
                    "update:search-input": function($event) {
                      _vm.studentSearchInput = $event
                    },
                    focus: _vm.clearStudentAutoComplete
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function(ref) {
                        var item = ref.item
                        var tile = ref.tile
                        return [
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.firstName) +
                                    " " +
                                    _vm._s(item.lastName) +
                                    "\n              "
                                ),
                                _c("span", { staticClass: "pl-1" }, [
                                  _vm._v(_vm._s(item.studentExtId))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-sub-title", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.schoolName) +
                                    "\n              "
                                ),
                                _c("span", { staticClass: "pl-1" }, [
                                  _vm._v("Grade: " + _vm._s(item.grade))
                                ])
                              ])
                            ],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "selection",
                      fn: function(ref) {
                        var item = ref.item
                        var selected = ref.selected
                        return [
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.firstName) +
                                    " " +
                                    _vm._s(item.lastName) +
                                    "\n            "
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selectedStudent,
                    callback: function($$v) {
                      _vm.selectedStudent = $$v
                    },
                    expression: "selectedStudent"
                  }
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "no-data" },
                    [
                      _c(
                        "v-list",
                        [
                          !_vm.studentSearchInput
                            ? _c("v-list-tile", [
                                _vm._v(
                                  "\n              Please type a Student.\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.studentSearchInput && !_vm.studentSearchLoading
                            ? _c("v-list-tile", { staticClass: "red--text" }, [
                                _vm._v(
                                  "\n              No Results\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { class: { "py-0": _vm.isMobile }, attrs: { xs12: "", sm4: "" } },
            [
              _c(
                "v-tooltip",
                { attrs: { disabled: !_vm.showTooltip, top: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        slot: "activator",
                        disabled: !_vm.selectedStudent,
                        block: ""
                      },
                      on: { click: _vm.onRetrieveStudentDetailsClicked },
                      slot: "activator"
                    },
                    [_vm._v("Retrieve Student Details\n        ")]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Display services and providers for selected student"
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", "mb-5": "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticStyle: { "background-color": "#1976d2" },
                      attrs: { "primary-title": "" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "white--text" },
                        [
                          _vm.studentServices
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "title" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.studentServices[0].firstName
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.studentServices[0].lastName
                                        ) +
                                        "\n                "
                                    ),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          disabled: !_vm.showTooltip,
                                          top: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "activator" },
                                            slot: "activator"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    (" +
                                                _vm._s(
                                                  _vm.studentServices[0]
                                                    .studentExtId
                                                ) +
                                                ")\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Student ID")])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          disabled: !_vm.showTooltip,
                                          top: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "pr-1",
                                            attrs: { slot: "activator" },
                                            slot: "activator"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.studentServices[0].gender
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Gender")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "pr-1" }, [
                                      _c("strong", [
                                        _vm._v(
                                          "Gr: " +
                                            _vm._s(_vm.studentServices[0].grade)
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { attrs: { clas: "pr-1" } },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.studentServices[0].schoolName
                                            ) +
                                            "\n                "
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: {
                                              disabled: !_vm.showTooltip,
                                              top: ""
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "activator" },
                                                slot: "activator"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    (" +
                                                    _vm._s(
                                                      _vm.studentServices[0]
                                                        .schoolCode
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v("Student's School Code")
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-alert",
                        { attrs: { value: _vm.errorMsg, type: "error" } },
                        [_vm._v(_vm._s(_vm.errorMsg))]
                      ),
                      _vm._v(" "),
                      _vm.studentServices
                        ? _c(
                            "v-expansion-panel",
                            {
                              attrs: { focusable: "" },
                              model: {
                                value: _vm.panel,
                                callback: function($$v) {
                                  _vm.panel = $$v
                                },
                                expression: "panel"
                              }
                            },
                            _vm._l(_vm.studentServices, function(
                              service,
                              index
                            ) {
                              return _c(
                                "v-expansion-panel-content",
                                {
                                  key: index,
                                  staticStyle: { "background-color": "#d3d3d3" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: {
                                        "orange--text": !service.active
                                      },
                                      attrs: { slot: "header" },
                                      slot: "header"
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  disabled: !_vm.showTooltip,
                                                  top: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      slot: "activator"
                                                    },
                                                    slot: "activator"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          service.planTypeName
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          service.serviceType
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v("Plan Type/Service")
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "pl-2" },
                                              [
                                                _vm._v(
                                                  "\n                      ESY: "
                                                ),
                                                service.esy
                                                  ? _c("span", [_vm._v("Yes")])
                                                  : _c("span", [_vm._v("No")])
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  disabled: !_vm.showTooltip,
                                                  top: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      slot: "activator"
                                                    },
                                                    slot: "activator"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm._f("formatDate")(
                                                            service.startDate
                                                          )
                                                        ) +
                                                        " -\n                        " +
                                                        _vm._s(
                                                          _vm._f("formatDate")(
                                                            service.endDate
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "Projected Start/End Dates"
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  disabled: !_vm.showTooltip,
                                                  top: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      slot: "activator"
                                                    },
                                                    slot: "activator"
                                                  },
                                                  [
                                                    _vm.isMobile
                                                      ? _c("span", [_c("br")])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        class: {
                                                          "pl-2": !_vm.isMobile
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            service.frequency
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v("Service Frequency")
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    {
                                      staticStyle: {
                                        "border-top": ".5px solid black"
                                      }
                                    },
                                    [
                                      _c("provider-autocomplete", {
                                        attrs: {
                                          service: service,
                                          showTooltip: _vm.showTooltip,
                                          isMobile: _vm.isMobile
                                        },
                                        on: {
                                          "update-services":
                                            _vm.updateStudentServices
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.studentServices
                        ? _c("v-flex", { staticClass: "light-gray-bg" }, [
                            _c("span", { staticClass: "font-italic" }, [
                              _vm._v(
                                '\n              No students.  Use the Select Student Search above to find a student,\n              then click on "Retrieve Student Details"\n            '
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showLoading ? _c("div", [_c("loading-component")], 1) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66624643", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66624643","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agency-scheduler/add-by-student/add-by-student.vue
// module id = null
// module chunks = 